import { useEffect, useState, useRef } from "react";

export const useCountdown = (
  startTime,
  durationMinutes,
  onEnd,
  rideId = "default"
) => {
  const STORAGE_KEY = `ride_timer_${rideId}`;
  const [remaining, setRemaining] = useState(0);

  const onEndRef = useRef(onEnd);
  const calledRef = useRef(false);

  useEffect(() => {
    onEndRef.current = onEnd;
  }, [onEnd]);

  useEffect(() => {
    // 1️⃣ Try to load from localStorage first
    let actualStart = startTime;
    let actualDuration = durationMinutes;

    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const { startTime: savedStart, durationMinutes: savedDuration } =
        JSON.parse(stored);
      actualStart = actualStart || savedStart;
      actualDuration = actualDuration || savedDuration;
    }

    if (!actualDuration || !actualStart) {
      setRemaining(0);
      return;
    }

    // 2️⃣ Save/Update in localStorage
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        startTime: actualStart,
        durationMinutes: actualDuration,
      })
    );

    // 3️⃣ Calculate end time
    const start = new Date(actualStart).getTime();
    const end = start + actualDuration * 60 * 1000;

    const tick = () => {
      const now = Date.now();
      const secs = Math.max(0, Math.floor((end - now) / 1000));
      setRemaining(secs);

      if (secs === 0 && !calledRef.current) {
        calledRef.current = true;
        onEndRef.current?.();
        localStorage.removeItem(STORAGE_KEY);
      }
    };

    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [startTime, durationMinutes, rideId]);

  return remaining;
};
